import { constants } from '../features/Eula'
import { launcherLaunchEve } from '../launcherBackend/launcher-command'
import {
    actions as launchProgressBarActions,
} from '../features/LaunchProgressBar'
import { getClientData } from '../reducers/clientLauncher'
import { CLIENT_LAUNCHER_SET_TOKEN } from '../constants'
import { resetClientLauncher, setClientLauncherEula } from '../actions'

const LoggerMiddleware = store => next => (action) => {
    switch (action.type) {
        case CLIENT_LAUNCHER_SET_TOKEN: {
            const result = next(action)
            const state = store.getState()

            const userId = action.payload.userId
            const data = getClientData(state, userId)

            if (data.eulaReady) {
                if (data.eulaOk) {
                    launcherLaunchEve(data.serverId, userId, data.profile, data.token)
                } else {
                    store.dispatch(
                        launchProgressBarActions.setLaunchProgress(data.serverId, userId, 0))
                }
                store.dispatch(resetClientLauncher(userId))
            }

            return result
        }

        case constants.EULA_ACCEPTED:
        case constants.EULA_NOT_OK: {
            const result = next(action)
            const state = store.getState()

            const userId = action.payload
            const data = getClientData(state, userId)

            if (data && data.tokenReady) {
                launcherLaunchEve(data.serverId, userId, data.profile, data.token)
                store.dispatch(resetClientLauncher(userId))
            } else {
                store.dispatch(setClientLauncherEula(userId, true))
            }

            return result
        }

        case constants.EULA_DECLINED: {
            const result = next(action)
            const state = store.getState()

            const userId = action.payload
            const data = getClientData(state, userId)

            if (data && data.tokenReady) {
                store.dispatch(launchProgressBarActions.setLaunchProgress(data.serverId, userId, 0))
                store.dispatch(resetClientLauncher(userId))
            } else {
                store.dispatch(setClientLauncherEula(userId, false))
            }

            return result
        }

        default:
            return next(action)
    }
}

export default LoggerMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/ClientLauncherMiddleware.js